import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { format, toDate } from 'date-fns';
import ExternalLink from '../../components/ExternalLink';
import styles from './PressRelease.module.css';
import RightArrowIcon from '../../components/icons/RightArrowIcon';

/**
 * @param {FF.ContentfulPressReleaseProps} props
 */
function PressRelease({ className = '', data }) {
  return (
    <article className={`${styles.article} ${className}`}>
      <ExternalLink className={styles.link} href={data.pressReleaseUrl.url}>
        {data.image && (
          <GatsbyImage
            alt={data.image.description}
            className={styles.image}
            image={data.image.gatsbyImageData}
            loading="lazy"
          />
        )}
        <div className={styles.textContent}>
          <p className={styles.source}>{data.source}</p>
          <div className={styles.titleWrapper}>
            <h3 className={styles.title}>{data.title}</h3>
            <RightArrowIcon />
          </div>
          {data.date && (
            <div className={styles.date}>
              {format(toDate(new Date(data.date)), 'MM.dd.yy')}
            </div>
          )}
        </div>
      </ExternalLink>
    </article>
  );
}

export default PressRelease;
